import React, { useState } from 'react';
import { Box, Button, Text, Thumbnail } from '@wix/design-system';
import styles from './styles.scss';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const THEME_SELECTION_WIDGET = 'THEME_SELECTION_WIDGET';
export const ThemeSelectionWidget = _ref => {
  let {
    data: {
      themes
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect,
      t
    },
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const [selected, setSelected] = useState(0);
  const logOnClick = (action, value) => {
    onWidgetAction(THEME_SELECTION_WIDGET, {
      action,
      value
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "normal",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, "Lastly, what design theme would you like to use?"), ' ', "You can change it later if needed in the AI composer"), /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: t
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "12px"
  }, Object.values(themes).map((theme, themeIdx) => /*#__PURE__*/React.createElement(Thumbnail, {
    key: theme.title,
    disabled: areControlsDisabled,
    selected: selected === themeIdx,
    contentAlignment: "top",
    onClick: () => {
      setSelected(themeIdx);
      logOnClick('theme-selection-changed', theme.title);
    },
    className: styles.thumb
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: theme.outerBackgroundColor,
    padding: "9px",
    height: "calc(100% - 18px)"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: theme.innerBackgroundColor,
    gap: "6px",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    minWidth: "105px"
  }, theme.colorPalette.map((color, colorIdx) => /*#__PURE__*/React.createElement(Box, {
    key: `${colorIdx}_${color}`,
    minWidth: `${Math.floor(105 / theme.colorPalette.length)}px`,
    minHeight: "50px",
    backgroundColor: color
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "12px 6px 12px 6px",
    maxWidth: "105px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold",
    overflowWrap: "anywhere"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: theme.headingColor,
      hyphens: 'auto'
    }
  }, theme.headingFontFamily.split(',')[0])), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    overflowWrap: "anywhere"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: theme.paragraphColor,
      hyphens: 'auto'
    }
  }, theme.paragraphFontFamily.split(',')[0]))))))))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "12px"
  }, Object.values(themes).map((theme, themeIdx) => /*#__PURE__*/React.createElement(Box, {
    key: `${themeIdx}_${theme.title}`,
    direction: "vertical",
    gap: "6px",
    minWidth: "123px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    align: "center",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, theme.title)))), /*#__PURE__*/React.createElement(Box, {
    paddingTop: "6px"
  }, /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: t
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: () => {
      const selectedTheme = Object.values(themes)[selected];
      emitSideEffect('theme-selected', {
        theme: selectedTheme,
        initialThemes: Object.values(themes)
      });
      logOnClick('theme-selected', JSON.stringify(selectedTheme));
      send(`Select theme: ${selectedTheme.title}`);
    },
    disabled: areControlsDisabled
  }, "Choose Theme"), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    priority: "secondary",
    onClick: () => {
      logOnClick('theme-selection-skipped');
      send('I will choose a theme later');
    },
    disabled: areControlsDisabled
  }, "I'll choose later")))));
};
//# sourceMappingURL=ThemeSelectionWidget.js.map